import { Col } from "reactstrap";
import { BorderColorTitle } from "../../../../constants";
import { BorderColorData } from "../../../../data/uiKits/HelperClasses";

const BorderColor = () => {
  return (
    <Col xxl="3" sm="6">
      <div className="border-wrapper h-100 dark-helper alert-light-light">
        <h3 className="mb-3">{BorderColorTitle}</h3>
        {BorderColorData.slice(0, 7).map((item, index) => (
          <div className="helper-common-box" key={index}>
            <div className={`helper-box border border-${item.color}`} />
            <span>{`.border-${item.color}`}</span>
          </div>
        ))}
      </div>
    </Col>
  );
};
export default BorderColor;
